import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * Get Rewards
 */
export function getRewards (callback) {
  database.ref('rewards').on('value', function(snapshot) {
    const rewards = snapshot.val();
    callback(true, rewards, null);
  });
}

export function getUserData(callback) {
  let totalPoints = 0;
  let totalRedemptions = 0;
  const rewardsRef = firebase.database().ref("users");
  rewardsRef.once('value', (snapshot) => {
    let allUserInfo = snapshot.val();
    let newState = [];
    var keys = [];
    if (allUserInfo) {
      keys = Object.keys(allUserInfo);
    };
    for (let k = 0; k < keys.length; ++k) {
      const user = allUserInfo[keys[k]];
      // get points from user and add them to running total
      let points = 0;
      if (user.point) {
        points = Number(user.point);
      }
      // get redemptions from user and add them to running total
      let redemptions = 0;
      if (user.loyaltyRewards) {
        redemptions = Number(Object.keys(user.loyaltyRewards).length);
      }
      totalRedemptions += redemptions;
      // get total points earned, calculate them if need be
      let totalPointsEarned = points;
      if (user.totalPointsEarned) {
        totalPointsEarned = Number(user.totalPointsEarned);
      }
      else if (user.loyaltyRewards) {
        totalPointsEarned += Object.keys(user.loyaltyRewards).length * 10;
      }
      totalPoints += totalPointsEarned;
      // get most recent redemption time
      let lastRedemption = '';
      if (user.lastRedemptionTime) {
        lastRedemption = user.lastRedemptionTime;
      }
      else {
        if (redemptions === 0) {
          lastRedemption = 'N/A';
        }
        else {
          lastRedemption = 'Unknown';
        }
      }
      // get last checkin time
      let lastCheckIn = '';
      if (user.lastCheckIn) {
        lastCheckIn = user.lastCheckIn;
      }
      else if (points === 0 && redemptions === 0) {
        lastCheckIn = 'N/A';
      }
      else {
        lastCheckIn = 'Unknown';
      }

      newState.push({
        name: user.name,
        email: user.email,
        points: points,
        totalPointsEarned: totalPointsEarned,
        lastCheckIn: lastCheckIn,
        redemptions: redemptions,
        lastRedemption: lastRedemption,
        id: user.id,
      });
    }
    let data = {};
    data.totalPoints = totalPoints;
    data.totalRedemptions = totalRedemptions;
    data.allUserInfo = newState;
    callback(true, data, null);
  });
}

/**
 * Create new reward
 */
export function createNewReward (data, callback) {
    var newId = database.ref().child('rewards').push().key;
    data["id"] = newId;

    database.ref('rewards/' + newId).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    })
}

/**
 * Send One-Time Reward
 */
export function sendOneTime (data, callback) {

    const { uid, reward } = data;
    var rewards = data.rewards;

    if (rewards === undefined) rewards = [];
    rewards.push(reward);

    database.ref('users/' + uid + '/maxCount').set(rewards.length);
    database.ref('users/' + uid + '/rewards').set(rewards, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, rewards, null);
        }
    })
}

export function updateReward (id, data, callback) {

  database.ref('rewards/' + id).update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

export function deleteReward (id, callback) {
  database.ref('rewards/' + id).remove((error) => callback(error));
}

export function getSettings (callback) {
   database.ref('settings').on('value', function(snapshot) {
     callback(snapshot.val() || {})
   });
}


export function updateSettings (data, callback) {
  var newId = database.ref('settings').child('links').push().key;
  data["id"] = newId;

  database.ref('settings').update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}
